module.exports = __webpack_public_path__ + "img/terroir-bright-4-mobile.55b51577.jpg";